import axios from "axios";


const get_options = (locale) => {
    let header = {};
    if (locale) {
        header = {
            headers: {
                'Accept-Language': locale
            }
        };
    }
    return header;
}


export const getModel1Registry = async (locale) => {
    const url = `/api/v1/registry/model1`;
    const res = await axios.get(url, get_options(locale) );
    return res.data;
}

export const getModel1ValidationRegistry = async (locale) => {
    const url = `/api/v1/registry/model1/validations`;
    const res = await axios.get(url, get_options(locale));
    return res.data;
}

export const getModel23Registry = async (locale) => {
    const url = `/api/v1/registry/model23`;
    const res = await axios.get(url, get_options(locale));
    return res.data;
}

export const getIncidentRegistry = async (locale) => {
    const url = `/api/v1/registry/incident`;
    const res = await axios.get(url, get_options(locale));
    return res.data;
}

export const getStationRegistry = async (locale) => {
    const url = `/api/v1/registry/station`;
    const res = await axios.get(url, get_options(locale));
    return res.data;
}

export const getWebgisRegistry = async (locale) => {
    const url = `/api/v1/registry/webgis`;
    const res = await axios.get(url, get_options(locale));
    return res.data;
}